module.exports = __webpack_public_path__ + "static/side-img-1-72d8bc6c451c9b83142c9b8a392ea992.png";